var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check"},[_c('div',{staticClass:"check-content"},[_c('div',{staticClass:"check-icon"},[_c('img',{attrs:{"src":_vm.CheckIcon}})]),_c('p',[_vm._v("已绑定")])])])}
var staticRenderFns = []

export { render, staticRenderFns }